// Shared helpers for the BL-596 time-display primitives (EventTime, RelativeTime).
// Kept here rather than copy-pasted per-component (sharing.md §4).

import type { TimeInput } from '@auctogon/time';

/**
 * Coerce a `TimeInput` to a machine-readable ISO string for a `<time dateTime>`
 * attribute, or `undefined` when the input isn't a valid instant (so the caller
 * can fall back to a plain `<span>`).
 */
export function toIso(input: TimeInput): string | undefined {
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}
